import { Loader2Icon } from "lucide-react"
import { Skeleton } from "./ui/skeleton"

const PageLoader = ({ message }: { message?: string }) => {
  return (
    <div className="mx-auto md:w-10/12 lg:w-8/12">
      <Skeleton className="flex h-60 w-full flex-col items-center justify-center gap-2 rounded-lg border">
        <Loader2Icon className="animate-spin" size="32" />
        <div className="text-sm">{message ?? "Cargando..."}</div>
      </Skeleton>
    </div>
  )
}

export { PageLoader }
